import React from "react";
import "./Intro.css";
import headerImage from "../../../img/Header_Accueil_Vehidoc.webp";
import { Link } from 'react-router-dom';

const Intro = () => {
  return (
    <section className="intro">
      <div className="intro-content">
        <img
          src={headerImage}
          alt="Bureau avec documents administratifs et ordinateur portable illustrant la gestion documentaire"
          title="Espace de travail VéhiDoc pour la gestion de documents administratifs"
          className="intro-image"
        />
        <div className="intro-title">
          <h1>Facilitez la vie de vos assistantes</h1>
          <h2>
            Gagnez du <span className="highlight">temps</span>, optimisez votre rentabilité
          </h2>
        </div>
        <div className="cta-action">
          <Link to="/login" className="cta-action-button">Accéder à mon espace</Link>
          <Link to="/contact" className="cta-action-button">Créer mon espace</Link>
        </div>
      </div>
    </section>
  );
};

export default Intro;
